<template>
  <!-- panel -->
  <el-drawer
    title="编辑"
    append-to-body
    direction="rtl"
    :size="300"
    :modal="false"
    :visible.sync="showPanel"
    :before-close="handlePanelClose"
  >
    <div class="edit-panel">
      <div class="label">
        <div>修改等级名称：</div>
        <input
          type="text"
          :value="label"
          @blur.stop="handleEditLabel($event)"
          @keydown.enter="handleEditLabel($event)"
        />
      </div>
      <draggable
        v-model="levelList"
        :animation="200"
        :group="'levelList'"
        :disabled="false"
        :ghostClass="'ghost'"
        :handle="'.edit-drag'"
        @start="dragLevel = true"
        @end="dragLevel = false"
        @change="handleSortLevel"
      >
        <div
          class="panel-item"
          v-for="(item, index) in levelList"
          :key="item.level + '-' + index"
          :class="{ active: currentLevelData.level === item.level }"
          @click="handleSelect(index)"
          @dblclick="handleEdit(index)"
        >
          <input
            v-if="editLevelIndex === index"
            type="text"
            :value="item.level"
            @blur.stop="handleEditLevel($event, index)"
            @keydown.enter="handleEditLevel($event, index)"
          />
          <span v-else>{{ item.level }}</span>
          <div class="edit-btns">
            <button class="btn edit-drag">
              <i class="icon wiki-editable-drag"></i>
            </button>
            <button class="btn edit-btn" @click.stop="handleEdit(index)">
              <i class="icon wiki-editable-edit"></i>
            </button>
            <button class="btn delete-btn" @click.stop="handleDelete(index)">
              <i class="icon wiki-editable-delete"></i>
            </button>
          </div>
        </div>
      </draggable>
      <div class="add-item" @click="handleAddLevel">
        <i class="icon iconfont icon-tianjia"></i>
        添加
      </div>
    </div>
  </el-drawer>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "EditPanel",
  components: {
    draggable
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    data: {
      type: Array,
      default: () => []
    },
    currentLevelData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showPanel: false,
      editLevelIndex: -1,
      dragLevel: false,
      levelList: this.data || []
    };
  },
  watch: {
    data(val) {
      this.levelList = val;
    }
  },
  mounted() {},

  methods: {
    open() {
      this.showPanel = true;
    },
    handlePanelClose() {
      this.showPanel = false;
    },
    handleAddLevel() {
      this.$emit("onAddLevel");
    },
    handleSelect(index) {
      this.$emit("onEdit", index);
    },
    handleEdit(index) {
      this.editLevelIndex = index;
      this.$emit("onEdit", index);
    },
    handleDelete(index) {
      this.$emit("onDelete", index);
    },
    handleEditLevel(e, index) {
      if (e.target.value === "") {
        this.$alert("等级不能设置为空！");
        return;
      }
      this.editLevelIndex = -1;
      this.$emit("onChangeLevel", index, e.target.value);
    },
    handleEditLabel(e) {
      this.$emit("onChangeLabel", e.target.value);
    },
    handleSortLevel() {
      this.$emit("onChange", this.levelList);
    }
  }
};
</script>

<style lang="less" scoped>
.edit-panel {
  padding: 0 20px;

  .label {
    margin-bottom: 12px;
    input {
      width: 100%;
      height: 36px;
      border-radius: 4px;
      border: 1px solid #333;
      margin-top: 12px;
      padding: 0 12px;
    }
  }

  .panel-item {
    position: relative;
    width: 100%;
    height: 36px;
    border: 1px solid #333;
    font-size: 14px;
    color: #333;
    line-height: 36px;
    padding: 0 50px 0 20px;
    margin-bottom: 10px;
    cursor: pointer;
    &.active {
      border: 1px solid red;
    }
    input {
      border: 1px solid #666;
      height: 22px;
    }
    .edit-btns {
      display: inline-flex;
      float: right;
      height: 20px;
      position: absolute;
      right: 6px;
      top: 6px;
      .btn {
        width: 20px;
        height: 20px;
        color: #ffffff;
        border-radius: 4px;
        margin-left: 3px;
        border: none;
        vertical-align: middle;
        line-height: 20px;
        text-align: center;
        &:hover {
          opacity: 0.9;
        }
        .icon {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .add-item {
    width: 100%;
    height: 36px;
    border: 1px dotted #555;
    font-size: 14px;
    color: #555;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    .icon {
      margin-right: 10px;
    }
  }
}
</style>
